let createShareByAmountOrder = null;
let currentSelectedPersonId = null;
let posType = 'classic';
let tableIdFromSplitPayment = '';
let selectedPersonCartData = {};

function setPerson() {
  const lastPerson = $('.select-person:last');

  if (!lastPerson || $(lastPerson).attr('data-payment-status') == 2) {
    return;
  }
  lastPerson.trigger('click');
}

function getSplitPaymentModal(
  tableId,
  organizerId,
  locationId,
  locationType = '',
  promocode = ''
) {
  $.ajax({
    type: 'POST',
    url: '/ajax/order/split_payment',
    data: {
      table_id: tableId,
      organizer_id: organizerId,
      location_id: locationId,
      location_type: locationType,
      promo_code: promocode,
    },
  })
    .done(function (data) {
      if (data.html !== undefined && data.html !== null) {
        $('#cart-modal').fadeOut();
        $('#order-storage-list-modal').fadeOut();
        $('.modal-backdrop').remove();
        if ($('#split-payment-cart-modal').length) {
          $('#split-payment-cart-modal').modal('hide');
          $('#split-payment-cart-modal').remove();
        }
        $('#context-menu').addClass('d-none');
        $('#order-storage-list-modal').modal('hide');

        $('#content').append(data.html);
        setTimeout(() => {
          $('#split-payment-cart-modal').modal('show');
          setPerson();
        }, 200);

        if (
          data.cart_products !== undefined &&
          data.cart_products !== null &&
          data.cart_products.length
        ) {
          LHSCartProducts = data.cart_products;
        }

        locationCart.table_number = tableId;
        tableIdFromSplitPayment = data.order_storage_ids[0] ?? '';
      }
    })
    .fail(function (data) {
      if (
        data.responseJSON.redirect_url !== undefined &&
        data.responseJSON.redirect_url !== null
      ) {
        document.location.href = data.responseJSON.redirect_url;
      }
    });
}

function getPersonProducts(shareByAmount = 0) {
  $.ajax({
    type: 'POST',
    url: '/ajax/order/get_table_customer_products',
    data: {
      table_customer_id: currentSelectedPersonId,
      table_id: locationCart.table_number,
      location_id: locationCart.location_id,
      location_type: locationCart.location_type,
      promo_code: $('#classic_promo_code').val() ?? '',
      share_by_amount: shareByAmount,
    },
  })
    .done(function (data) {
      if (data.html !== undefined && data.html !== null) {
        $('#split-payment-product-container').empty();
        $('#split-payment-product-container').html(data.html);
        softProductTableList();
        softPersonProductTableList();

        if ($('#split-by-sum').is(':checked')) {
          suggestedShareAmount();
        }
      }
      if (data.isNoMoreProduct) {
        $('#split-payment-cart-modal').modal('hide');
        setTimeout(() => {
          $('#split-payment-cart-modal').remove();
          $('.modal-backdrop').remove();
        }, 300);
      }
      if (
        data.location_id !== undefined &&
        data.location_id !== null &&
        data.location_id == locationCart.location_id
      ) {
        selectedPersonCartData = data;
      }
    })
    .fail(function (data) {
      if (
        data.responseJSON.redirect_url !== undefined &&
        data.responseJSON.redirect_url !== null
      ) {
        document.location.href = data.responseJSON.redirect_url;
      }
    });
}

function softProductTableList() {
  if ($('.share-payment-product-list').length) {
    const splitProductTableBody = $('.share-payment-product-list')[0];

    Sortable.create(splitProductTableBody, {
      handle: '.product-table-reorder',
      animation: 150,
      draggable: '.share-payment-product-container',
      ghostClass: 'sortable-ghost',
      forceFallback: true,
      dataIdAttr: 'data-product-table-id',
      store: {
        set: function (sortable) {
          let order = sortable.toArray();
          ajaxListOrder(order);
        },
      },
    });
  }
}

function softPersonProductTableList() {
  if ($('.share-payment-person-product-list').length) {
    const splitedProductTableBody = document.getElementsByClassName(
      'share-payment-person-product-list'
    )[0];

    Sortable.create(splitedProductTableBody, {
      handle: '.person-product-table-reorder',
      animation: 150,
      sort: true,
      delay: 0,
      touchStartThreshold: 0,
      disabled: false,
      draggable: '.share-payment-person-product-container',
      direction: 'vertical',
      ghostClass: 'sortable-ghost',
      dataIdAttr: 'data-product-table-id',
      removeCloneOnHide: true,
      store: {
        set: function (sortable) {
          let order = sortable.toArray();

          ajaxPersonProductListOrder(order);
        },
      },
    });
  }
}

function ajaxListOrder($order) {
  $.ajax({
    type: 'POST',
    url: '/ajax/order/list_sort',
    data: {
      serialized_post: JSON.stringify($order),
    },
  })
    .done(function (data) {
      if (data === true) {
        popupAlert();
      }
    })
    .fail(function (data) {
      if (
        data.responseJSON.redirect_url !== undefined &&
        data.responseJSON.redirect_url !== null
      ) {
        document.location.href = data.responseJSON.redirect_url;
      }
    });
}

function ajaxPersonProductListOrder($order) {
  $.ajax({
    type: 'POST',
    url: '/ajax/order/person_product_list_sort',
    data: {
      serialized_post: JSON.stringify($order),
      table_customer_id: currentSelectedPersonId,
      table_id: locationCart.table_number,
    },
  })
    .done(function (data) {
      if (data) {
        popupAlert();
        selectedPersonCartData = { ...selectedPersonCartData, ...data };
      }
    })
    .fail(function (data) {
      if (
        data.responseJSON.redirect_url !== undefined &&
        data.responseJSON.redirect_url !== null
      ) {
        document.location.href = data.responseJSON.redirect_url;
      }
    });
}

$(document).ready(function () {
  let p = $('body').attr('p');

  posType = $('#classic-location-products').data('pos-type');

  if (p == 'events') {
    const organizerId = $('body').attr('organizer_id');
    let locationId =
      $('#classic-location-products').attr('data-location-id') ??
      $('#location').attr('data-location-id');
    const isPax = $('body').attr('is_pax') == 1;
    let isLongPress = false;
    let longPressTimer;
    let isDivideLongPress = false;
    let longPressTimerForDivide;
    let customSplitting = false;
    let isCustomSplitting = false;
    let targetProductForSplit = null; // Store which product to split

    const params = extractUrlQuery();

    if (
      params['table-id'] !== undefined &&
      params['table-id'] !== null &&
      params['table-id'] !== '' &&
      params['order-type'] !== 'payment_split'
    ) {
      let locationId = $('#location-id').val();
      getSavedOrder(organizerId, locationId, params['table-id'], true);
      removeQueryParams(['table-id', 'order', 'payment-split-id', 'shop-type']);
    }

    $(document).on('click', '#add-person', function () {
      const tableId = $(this).attr('data-table-id');
      const customerName = $('#customer-name-input').val().trim();

      $.ajax({
        type: 'POST',
        url: '/ajax/order/new_table_customer',
        data: { table_id: tableId, customer_name: customerName },
      })
        .done(function (data) {
          tableIdFromSplitPayment = tableId;
          if (
            data.table_customer_item_html !== undefined &&
            data.table_customer_item_html !== null
          ) {
            $('#table-customer-list-container').append(
              data.table_customer_item_html
            );
            $('#customer-name-input').val('');
          } else if (data.html !== undefined && data.html !== null) {
            $('#person-row').append(data.html);
            if ($('#split-by-sum').is(':checked')) {
              suggestedShareAmount();
            }
            popupAlert();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    $(document).on('click', '.remove-person', function (e) {
      e.stopPropagation();
      let isShareByAmount = $('#split-by-sum').is(':checked') ? 1 : 0;
      const personId = $(this).attr('data-table-guest-id');
      const hasProduct =
        parseInt(
          $(this).closest('.select-person').find('.product-count').text()
        ) > 0;

      if (!isShareByAmount && hasProduct) {
        const $confirmDiv = $(`#remove-person-${personId}`);
        $confirmDiv.removeClass('d-none');
      } else {
        const parentDiv = $(`#person-${personId}`).closest('.select-person');
        removePerson(personId, parentDiv);
      }
    });

    $(document).on('click', '.remove-person-cancel', function (e) {
      const $confirmDiv = $(this).closest('.remove-confirm-div');
      $confirmDiv.addClass('d-none');
    });

    $(document).on('click', '.remove-confirm-div', function (e) {
      var $parentDiv = $(this);
      var $childDiv = $parentDiv.find('.remove-confirm-content');

      if (!$parentDiv.hasClass('d-none')) {
        if (
          !$childDiv.is(event.target) &&
          $childDiv.has(event.target).length === 0
        ) {
          $parentDiv.addClass('d-none');
        }
      }
    });

    function removePerson(personId, parentDiv) {
      $.ajax({
        type: 'POST',
        url: '/ajax/order/remove_table_customer',
        data: {
          organizer_id: organizerId,
          table_customer_id: personId,
          table_id: locationCart.table_number,
          location_id: locationCart.location_id,
          location_type: locationCart.location_type,
        },
      })
        .done(function (data) {
          let isShareByAmount = $('#split-by-sum').is(':checked') ? 1 : 0;
          if (
            !isShareByAmount &&
            data.html !== undefined &&
            data.html !== null
          ) {
            $('#remove-person-confirmation-modal').remove();
            parentDiv.fadeOut(100);

            popupAlert();
            $('#split-payment-product-container').empty();
            $('#split-payment-product-container').html(data.html);
            softProductTableList();
            softPersonProductTableList();
            setTimeout(() => {
              parentDiv.remove();
              let personCount = $('.select-person').length;
              if (personCount === 0) {
                $('#split-payment-cart-modal').modal('hide');
                $('#split-payment-cart-modal').remove();
                if ($('.modal-backdrop').length) {
                  $('.modal-backdrop').remove();
                }
                $('.cart-modal').show();
              }
              setPerson();
            }, 500);
          } else {
            $('#remove-person-confirmation-modal').remove();
            parentDiv.fadeOut(100);

            popupAlert();

            setTimeout(() => {
              parentDiv.remove();
              let personCount = $('.select-person').length;

              if (personCount === 0) {
                $('#split-payment-cart-modal').modal('hide');
                $('#split-payment-cart-modal').remove();
                if ($('.modal-backdrop').length) {
                  $('.modal-backdrop').remove();
                }
                $('.cart-modal').show();
              }

              setPerson();
            }, 500);
          }

          if (
            data.location_id !== undefined &&
            data.location_id !== null &&
            data.location_id == locationCart.location_id
          ) {
            selectedPersonCartData = data;
          }

          if ($('.select-person').length === 1) {
            locationCart.products = [];
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }

    $(document).on('click', '.remove-person-confirm', function (e) {
      e.stopPropagation();

      const personId = $(this).attr('data-person-id');
      const parentDiv = $(`#person-${personId}`).closest('.select-person');
      removePerson(personId, parentDiv);
    });

    $(document).on(
      'mousedown touchstart',
      '.share-payment-product',
      function (e) {
        e.preventDefault();
        const productTableId = $(this).attr('data-product-table-id');
        const fromTableId = $('#split-payment-product-container').attr(
          'data-table-id'
        );
        const splitByOne = $(this).attr('data-split-by-one') ?? 0;
        const hasSplitProdcut =
          $(this).attr('data-has-split-product') == 1 ||
          (productTableId.split('-')[1] == 's' && splitByOne == 0)
            ? true
            : false;

        longPressTimer = setTimeout(function () {
          isLongPress = true;
          if (hasSplitProdcut == 1) {
            alert('Kan ikke flytte delt vare til en annen bord');
            return;
          }

          $.ajax({
            type: 'POST',
            url: '/api/v1/private/product-table/get-product-table-menu-modal',
            data: {
              organizer_id: organizerId,
              location_id: locationId,
              products_in_cart: [],
              identifier: fromTableId,
              productTableId: productTableId.split('-')[0],
              isMoveProduct: true,
              isMoveFromCustomer: productTableId.includes('-') ? 1 : 0,
              isSplitByOne: splitByOne,
            },
          })
            .done(function (data) {
              if (data.html !== undefined && data.html !== null) {
                if ($('#product-table-menu-modal').length > 0) {
                  $('#product-table-menu-modal').remove();
                }

                if ($('#order-table-list-modal').length > 0) {
                  $('#order-table-list-modal').remove();
                }

                $('#content').append(data.html);
                $('#product-table-menu-modal').modal('show');
              }
            })
            .fail(function (data) {
              if (
                data.responseJSON.redirect_url !== undefined &&
                data.responseJSON.redirect_url !== null
              ) {
                document.location.href = data.responseJSON.redirect_url;
              }
            });
        }, 1000);
      }
    );

    $(document).on('click', '#delete-product-table', function () {
      const productTableId = $(this).attr('data-product-table-id');

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/product-table/get-product-table-delete-modal',
        data: {
          productTableId,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            if ($('#product-table-delete-modal').length) {
              $('#product-table-delete-modal').remove();
            }
            $('#content').append(data.html);
            $('#product-table-delete-modal').modal('show');
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    $(document).on('click', '#cancel-delete-product', function () {
      $('#product-table-delete-modal').modal('hide');
    });

    $(document).on('click', '#confirm-delete-product', function () {
      const productTableId = $(this).attr('data-product-table-id');
      const productName =
        $(this).attr('data-product-name') || 'dette produktet';

      $('#product-table-menu-error-container').html('');

      $.ajax({
        type: 'POST',
        url: '/ajax/order/delete_product_table',
        data: {
          organizer_id: organizerId,
          location_id: locationId,
          product_table_id: productTableId,
          table_id: locationCart.table_number,
        },
      })
        .done(function (data) {
          if (data.success) {
            popupAlert();
            setPerson();
            fetchDataAndSend();
            $('#product-table-menu-modal').modal('hide');
            $('#product-table-delete-modal').modal('hide');
          } else {
            const errorHtml = getAlertHtml(
              'Kunne ikke fjerne produktet fra bordet',
              'danger'
            );
            $('#product-table-menu-error-container').html(errorHtml);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          const errorHtml = getAlertHtml(
            'Kunne ikke fjerne produktet fra bordet',
            'danger'
          );
          $('#product-table-menu-error-container').html(errorHtml);
        });
    });

    $(document).on('mouseup touchend', '.share-payment-product', function () {
      clearTimeout(longPressTimer);
      isLongPress = false;
    });

    $(document).on(
      'mouseleave touchend',
      '.share-payment-product',
      function () {
        clearTimeout(longPressTimer);
        isLongPress = false;
      }
    );

    $(document).on('click', '.order-table-product-move', function () {
      const parentContainer = $('#moving-product-to-table-container');
      const productTableIdToMove = parentContainer.attr(
        'data-product-table-id'
      );
      const isMoveFromCustomer =
        parentContainer.attr('data-is-move-from-customer') == 1;
      const splitByOne = parentContainer.attr('data-is-split-by-one');
      const toIdentifier = $(this).attr('data-identifier');
      const fromIdentifier = $(this).attr('data-from-identifier');

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/product-table/move-product-to-table',
        data: {
          organizer_id: organizerId,
          location_id: locationId,
          fromIdentifier,
          toIdentifier,
          productTableId: productTableIdToMove,
          splitByOne,
        },
      })
        .done(function (data) {
          if (data.success) {
            if (isMoveFromCustomer) {
              const customerCountDiv = $(
                `#customer-product-count-${currentSelectedPersonId}`
              );
              const customerCount = parseInt(customerCountDiv.text());
              if (customerCount > 0) {
                customerCountDiv.text(customerCount - 1);
              }
            }

            setPerson();

            $('#order-table-list-modal').modal('hide');
            if ($('#product-table-menu-modal').length) {
              $('#product-table-menu-modal').modal('hide');
            }
            popupAlert();
            fetchDataAndSend();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (data.responseJSON.error_message) {
            return alert(data.responseJSON.error_message);
          }
        })
        .always(function () {});
    });
    $(document).on('click', '#split-payment', function (e, data) {
      const table_id = $(this).attr('data-identifier') ?? data?.tableId;
      const promo_code = $('#classic_promo_code').val();
      getSplitPaymentModal(
        table_id,
        organizerId,
        locationCart.location_id,
        locationCart.location_type,
        promo_code ?? ''
      );
    });

    $(document).on('click', '.select-person', function (event, data) {
      $('.person-btn').removeClass('selected');
      const personName = $(this).find('.name-container').text();
      const personId = parseInt($(this).data('person-id'));

      $('.select-person').removeClass('selected');
      $(this).addClass('selected');
      currentSelectedPersonId = personId;
      let isShareByAmount = $('#split-by-sum').is(':checked') ? 1 : 0;
      getPersonProducts(isShareByAmount);
    });

    $(document).on('click', '#refresh-table-details', function () {
      let isShareByAmount = $('#split-by-sum').is(':checked') ? 1 : 0;
      getPersonProducts(isShareByAmount);
    });

    $(document).on('input', '.person-name-input', function () {
      const personName = $(this).val();
      $('#selected-name').text(personName);
    });

    $(document).on('click', '.divide-product', function (e, data) {
      e.preventDefault(); // Prevent default button behavior
      isCustomSplitting = data?.cSplitting || customSplitting;
      let customSplitAmount = data?.customSplitAmount || null;
      // Prevent action if it was a long press
      if (isDivideLongPress) {
        isDivideLongPress = false;
        return;
      }
      if (!isCustomSplitting) {
        if ($('.select-person').length <= 1) {
          return alert('Det må være minst 2 personer for å dele en vare');
        }
      }

      const productId = $(this).attr('data-product-id');
      const product_table_id = $(this).data('product-table-id');
      $.ajax({
        type: 'POST',
        url: '/ajax/order/divide_product',
        data: {
          table_customer_id: currentSelectedPersonId ?? null,
          organizer_id: organizerId,
          product_id: productId,
          location_id: locationCart.location_id,
          table_id: locationCart.table_number,
          location_type: locationCart.location_type,
          product_table_id,
          promo_code: $('#classic_promo_code').val() ?? '',
          custom_split_number: customSplitAmount,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $('#split-payment-product-container').empty();
            $('#split-payment-product-container').html(data.html);
            softProductTableList();
            softPersonProductTableList();
          }

          if (
            data.location_id !== undefined &&
            data.location_id !== null &&
            data.location_id == locationCart.location_id
          ) {
            selectedPersonCartData = data;
          }
          if (isCustomSplitting) {
            $('#product-table-customized-split-number-modal').modal('hide');
            $('#custom-split-amount').val('');
            customSplitting = false;
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    //Getting Custom splitting
    $(document).on('mousedown touchstart', '.divide-product', function (e) {
      e.preventDefault();
      // customSplitting = true;
      const productId = $(this).attr('data-product-id');
      const product_table_id = $(this).data('product-table-id');
      targetProductForSplit = $(this); // Store the target element
      longPressTimerForDivide = setTimeout(function () {
        isDivideLongPress = true;
        $.ajax({
          type: 'POST',
          url: '/api/v1/private/product-table/get-product-table-split-number-modal',
          data: {
            productTableId: product_table_id,
          },
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              if (
                $('#product-table-customized-split-number-modal').length > 0
              ) {
                $('#product-table-customized-split-number-modal').remove();
              }

              $('#content').append(data.html);
              $('#product-table-customized-split-number-modal').modal('show');
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
          });
      }, 1000);
    });

    $(document).on('mouseup touchend', '.divide-product', function () {
      clearTimeout(longPressTimerForDivide);
      customSplitting = false;
    });

    $(document).on('mouseleave touchend', '.divide-product', function () {
      clearTimeout(longPressTimerForDivide);
      isDivideLongPress = false;
      customSplitting = false;
    });

    $(document).on('click', '#confirm-split-number', function (e) {
      e.preventDefault(); // Prevent default button behavior
      if (targetProductForSplit) {
        let customSplitAmount = null;
        customSplitAmount = parseInt($('#custom-split-amount').val(), 10) || 0;
        // must be an integer >= 2; default to 2 otherwise (reject 0,1, negatives, non-integers)
        if (isNaN(customSplitAmount) || customSplitAmount < 2) {
          $('#custom-split-amount').val(2);
          alert('Delingsbeløpet må være et heltall større enn eller lik 2');
          customSplitAmount = 2;
          return;
        }
        targetProductForSplit.trigger('click', {
          cSplitting: true,
          customSplitAmount: customSplitAmount,
        });
        targetProductForSplit = null; // Reset after use
      }
    });

    $(document).on('click', '#cancel-split-number', function () {
      $('#product-table-customized-split-number-modal').modal('hide');
      customSplitting = false;
    });

    //end Getting Custom splitting

    $(document).on('click', '.remove-divided-product', function () {
      const product_table_id = $(this).data('product-table-id');
      const product_table_split_id = $(this).data('product-table-split-id');

      const splitProductCount = $(this).data('split-product-count');

      if (splitProductCount == 1) {
        return alert(
          'Du har allerede tildelt ett av de oppdelte produktene til en kunde.'
        );
      }

      $.ajax({
        type: 'POST',
        url: '/ajax/order/remove_divide_product',
        data: {
          table_customer_id: currentSelectedPersonId ?? null,
          organizer_id: organizerId,
          location_id: locationCart.location_id,
          table_id: locationCart.table_number,
          location_type: locationCart.location_type,
          product_table_id,
          product_table_split_id,
          promo_code: $('#classic_promo_code').val() ?? '',
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $('#split-payment-product-container').empty();
            $('#split-payment-product-container').html(data.html);
            softProductTableList();
            softPersonProductTableList();
          }

          if (
            data.location_id !== undefined &&
            data.location_id !== null &&
            data.location_id == locationCart.location_id
          ) {
            selectedPersonCartData = data;
            $(`#customer-product-count-${currentSelectedPersonId}`).text(
              data.products.length || 0
            );
          }
          if (
            data.disabled_switch !== undefined &&
            data.disabled_switch !== null
          ) {
            $('#split-by-sum').prop('disabled', data.disabled_switch);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    $(document).on('click', '.add-divided-product-to-person', function () {
      if (!currentSelectedPersonId) {
        return alert('Vennligst velg en person');
      }

      const product_table_split_id = $(this).data('product-table-split-id');
      const customerProductCount = parseFloat(
        $(`#customer-product-count-${currentSelectedPersonId}`).text()
      );
      $.ajax({
        type: 'POST',
        url: '/ajax/order/add_divided_product_to_person',
        data: {
          table_customer_id: currentSelectedPersonId,
          table_id: locationCart.table_number,
          location_id: locationCart.location_id,
          location_type: locationCart.location_type,
          product_table_split_id,
          promo_code: $('#classic_promo_code').val() ?? '',
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $('#split-payment-product-container').empty();
            $('#split-payment-product-container').html(data.html);
            softProductTableList();
            softPersonProductTableList();
          }

          if (
            data.location_id !== undefined &&
            data.location_id !== null &&
            data.location_id == locationCart.location_id
          ) {
            selectedPersonCartData = data;
            $(`#customer-product-count-${currentSelectedPersonId}`).text(
              data.products.length || 0
            );
          }
          if (
            data.disabled_switch !== undefined &&
            data.disabled_switch !== null
          ) {
            $('#split-by-sum').prop('disabled', data.disabled_switch);
          }

          if (
            window.globalSocket &&
            window.globalSocket.readyState === WebSocket.OPEN
          ) {
            window.globalSocket.send(
              JSON.stringify({
                type: 'update_dinein_cart',
                tableCustomerId: currentSelectedPersonId,
                products: data.products,
              })
            );
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    $(document).on('click', '.add-to-customer', function () {
      if (!currentSelectedPersonId) {
        return alert('Vennligst velg en person');
      }

      const addByOne = $(this).attr('data-add-one');
      const productId = $(this).data('product-id');
      const productTableId = $(this).data('product-table-id');
      const customerProductCount = parseFloat(
        $(`#customer-product-count-${currentSelectedPersonId}`).text()
      );

      $.ajax({
        type: 'POST',
        url: '/ajax/order/update_product_table',
        data: {
          table_customer_id: currentSelectedPersonId,
          product_id: productId,
          table_id: locationCart.table_number,
          location_id: locationCart.location_id,
          location_type: locationCart.location_type,
          product_table_id: productTableId,
          split_by_one: addByOne ? 1 : 0,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $('#split-payment-product-container').empty();
            $('#split-payment-product-container').html(data.html);
            softProductTableList();
            softPersonProductTableList();
          }

          if (
            data.location_id !== undefined &&
            data.location_id !== null &&
            data.location_id == locationCart.location_id
          ) {
            selectedPersonCartData = data;
            $(`#customer-product-count-${currentSelectedPersonId}`).text(
              data.products.length || 0
            );
          }

          if (
            data.disabled_switch !== undefined &&
            data.disabled_switch !== null
          ) {
            $('#split-by-sum').prop('disabled', data.disabled_switch);
          }

          if (
            window.globalSocket &&
            window.globalSocket.readyState === WebSocket.OPEN
          ) {
            window.globalSocket.send(
              JSON.stringify({
                type: 'update_dinein_cart',
                tableCustomerId: currentSelectedPersonId,
                products: data.products,
              })
            );
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    $(document).on('click', '.remove-splited-product', function () {
      const productId = $(this).data('product-id');
      const product_table_id = $(this).data('product-table-id');
      const product_table_split_id = $(this).data('product-table-split-id');
      const customerProductCount = parseFloat(
        $(`#customer-product-count-${currentSelectedPersonId}`).text()
      );
      if (product_table_id) {
        $.ajax({
          type: 'POST',
          url: '/ajax/order/update_product_table',
          data: {
            table_customer_id: currentSelectedPersonId,
            product_id: productId,
            table_id: locationCart.table_number,
            location_id: locationCart.location_id,
            location_type: locationCart.location_type,
            product_table_id,
            promo_code: $('#classic_promo_code').val() ?? '',
          },
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              $('#split-payment-product-container').empty();
              $('#split-payment-product-container').html(data.html);
              softProductTableList();
              softPersonProductTableList();
            }

            if (
              data.location_id !== undefined &&
              data.location_id !== null &&
              data.location_id == locationCart.location_id
            ) {
              selectedPersonCartData = data;
              $(`#customer-product-count-${currentSelectedPersonId}`).text(
                data.products.length || 0
              );
            }

            if (
              data.disabled_switch !== undefined &&
              data.disabled_switch !== null
            ) {
              $('#split-by-sum').prop('disabled', data.disabled_switch);
            }

            if (
              window.globalSocket &&
              window.globalSocket.readyState === WebSocket.OPEN
            ) {
              window.globalSocket.send(
                JSON.stringify({
                  type: 'update_dinein_cart',
                  tableCustomerId: currentSelectedPersonId,
                  products: data.products,
                })
              );
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
          });
      }

      if (product_table_split_id) {
        $.ajax({
          type: 'POST',
          url: '/ajax/order/add_divided_product_to_person',
          data: {
            table_customer_id: currentSelectedPersonId,
            table_id: locationCart.table_number,
            location_id: locationCart.location_id,
            location_type: locationCart.location_type,
            product_table_split_id,
            promo_code: $('#classic_promo_code').val() ?? '',
          },
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              $('#split-payment-product-container').empty();
              $('#split-payment-product-container').html(data.html);
              softProductTableList();
              softPersonProductTableList();
            }

            if (
              data.location_id !== undefined &&
              data.location_id !== null &&
              data.location_id == locationCart.location_id
            ) {
              selectedPersonCartData = data;

              $(`#customer-product-count-${currentSelectedPersonId}`).text(
                data.products.length || 0
              );
            }
            if (
              data.disabled_switch !== undefined &&
              data.disabled_switch !== null
            ) {
              $('#split-by-sum').prop('disabled', data.disabled_switch);
            }

            if (
              window.globalSocket &&
              window.globalSocket.readyState === WebSocket.OPEN
            ) {
              window.globalSocket.send(
                JSON.stringify({
                  type: 'update_dinein_cart',
                  tableCustomerId: currentSelectedPersonId,
                  products: data.products,
                })
              );
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
          });
      }
    });

    $(document).on('click', '#add-splited-product-to-cart', function () {
      emptyCartOnModalClose = false;
      posType = $('body').attr('pos_type');
      tableIdFromSplitPayment = $('#add-person').data('table-id');
      let shareAmount = $('#share-amount').val();
      $('#split-payment-cart-modal').modal('hide');

      setTimeout(() => {
        $('#split-payment-cart-modal').remove();
        $('.modal-backdrop').remove();
      }, 100);

      locationCart.products = [];
      locationCart.customer_id = '';
      $('.customer-item').removeClass('selected');

      if (posType === 'scroll') {
        setLocationCart({
          ...locationCart,
          ...selectedPersonCartData,
          checkout_type: 'normal',
          table_customer_id: currentSelectedPersonId,
          table_number: tableIdFromSplitPayment,
          table_id: tableIdFromSplitPayment,
          share_amount: shareAmount || 0,
        });
      } else if (posType === 'classic') {
        setClassicLocationCart({
          ...locationCart,
          ...selectedPersonCartData,
          checkout_type: 'normal',
          table_customer_id: currentSelectedPersonId,
          table_number: tableIdFromSplitPayment,
          table_id: tableIdFromSplitPayment,
          share_amount: parseFloat(shareAmount) || 0,
          is_takeaway_checked: selectedPersonCartData.is_takeaway_checked || 0,
        });
      }
    });

    $(document).on('click', '#print-customer-receipt', function () {
      const tableId = $('#add-person').attr('data-table-id');
      const disabledOnClick = $(this);
      const buttonText = disabledOnClick.text();
      const btnWidth = disabledOnClick.outerWidth();
      disabledOnClick.css('width', btnWidth + 'px');
      disabledOnClick.css('border', '1px solid #1355ff');
      disabledOnClick.prop('disabled', true);
      disabledOnClick.html('<i class="spinner-border spinner-border-sm"></i>');
      $.ajax({
        type: 'POST',
        url: '/api/v1/private/printer/advance-receipt',
        data: {
          organizer_id: organizerId,
          table_customer_id: currentSelectedPersonId,
          locaiton_id: locationId,
          table_id: tableId,
        },
      })
        .done(function (data) {
          if (data && data.print_data && data.html) {
            disabledOnClick.prop('disabled', false);
            disabledOnClick.html(buttonText);
            if ($('#printer-list-modal').length) {
              $('#printer-list-modal').remove();
            }
            $('#content').append(data.html);
            $('#printer-list-modal').modal('show');
          }
          // }
        })
        .fail(function (data) {
          disabledOnClick.prop('disabled', false);
          disabledOnClick.html(buttonText);
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    $(document).on('click', '#print-table-receipt', function () {
      const tableId = $(this).attr('data-table-id');

      $.ajax({
        type: 'POST',
        url: '/api/v1/private/printer/table-receipt',
        data: {
          organizer_id: organizerId,
          table_id: tableId,
          location_id: locationId,
        },
      })
        .done(function (data) {
          if (data && data.html) {
            if ($('#printer-list-modal').length) {
              $('#printer-list-modal').remove();
            }
            $('#content').append(data.html);
            $('#printer-list-modal').modal('show');
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    function updateSelectedPersonForShareByAmount() {
      var selectedPerson = $('.select-person.selected');
      var avatar = selectedPerson.find('.person-btn');
      var nameContainer = selectedPerson.find('.name-container');

      var avatarBgColor = avatar.css('background-color');
      $('.person-icon-btn').css('background-color', avatarBgColor);

      var personName = nameContainer.text().trim();
      $('.person-name').text('Betalende person: ' + personName);
    }

    $(document).on('focus', '.payment-split-input', function () {
      let totalAmount = parseFloat(
        $('#total-amount').attr('data-total-amount')
      );
      let otherValues = 0;
      const giftCardAmountAvailable = $(this).data('remaining-credit-limit');

      let suggestedAmount = totalAmount - otherValues;
      if (giftCardAmountAvailable !== undefined) {
        suggestedAmount = Math.min(suggestedAmount, giftCardAmountAvailable);
      }
      $(this).val(suggestedAmount > 0 ? suggestedAmount.toFixed(2) : '');
      setTimeout(() => {
        $(this).select();
      });
    });

    $(document).on('input', '#share-amount', function () {
      let amount = $(this).val();
      const remainingAmount = $(this).data('remaining') ?? 0;
      if (
        amount &&
        !isNaN(amount) &&
        parseFloat(amount) > 0 &&
        parseFloat(amount) <= remainingAmount
      ) {
        $('#add-splited-product-to-cart').prop('disabled', false);
      }

      if (parseFloat(amount) > parseFloat(remainingAmount)) {
        $('#add-splited-product-to-cart').prop('disabled', true);
      }
    });

    $(document).on('change', '#split-by-sum', function () {
      const hasSplitedByPerson =
        $('.split-product-row').length > 0 ||
        $('.share-payment-person-product-container').length > 0;
      if (hasSplitedByPerson) {
        $('#split-by-sum').prop('checked', false);
        return alert('Det finnes allerede delte produkter');
      }
      let share_by_amount = $(this).is(':checked') ? 1 : 0;
      let selected_person_id = $('.select-person.selected').data('person-id');

      if (share_by_amount) {
        $.ajax({
          url: '/api/v1/private/order/toggle-share-payment',
          type: 'POST',
          data: {
            share_by_amount,
            table_customer_id: selected_person_id,
          },
          success: function (response) {
            if (
              response.success &&
              response.html !== undefined &&
              response.html !== null &&
              response.html !== ''
            ) {
              $('#split-payment-product-container').html(response.html);
              suggestedShareAmount();
            }
          },
          error: function (xhr, status, error) {
            if (
              xhr.responseJSON.redirect_url !== undefined &&
              xhr.responseJSON.redirect_url !== null
            ) {
              document.location.href = xhr.responseJSON.redirect_url;
            }
            console.error('AJAX error:', status, error);
          },
        });
      } else {
        getPersonProducts();
      }
    });

    createShareByAmountOrder = function (
      amount,
      payment_method,
      table_id,
      table_customer_id,
      location_id,
      organizer_id,
      terminal_id,
      terminal_number,
      gift_code
    ) {
      if (!amount || isNaN(amount) || amount <= 0) {
        return alert('Vennligst oppgi et gyldig beløp for deling.');
      }

      if (!payment_method) {
        return alert('Vennligst velg en betalingsmetode.');
      }

      if (!table_customer_id) {
        return alert('Vennligst velg en person for deling.');
      }

      return $.ajax({
        type: 'POST',
        url: '/api/v1/private/order/create-share-by-amount-order',
        data: {
          amount: parseFloat(amount),
          payment_method,
          table_customer_id,
          location_id,
          table_id,
          terminal_id: terminal_id || null,
          terminal_number: terminal_number || null,
          gift_code: gift_code || '',
        },
      })
        .done(function (data) {
          if (data.success) {
            if (
              data.payment_redirect_url !== undefined &&
              data.payment_redirect_url !== null
            ) {
              document.location.href = data.payment_redirect_url;
              return;
            }

            if (locationCart.products.length <= 0) {
              emptyAllCart('completed_share_by_amount');
            }
            if (
              data.remaining_amount &&
              data.remaining_amount > 0.1 &&
              (terminal_id === undefined || terminal_id === '')
            ) {
              getSavedOrder(organizer_id, location_id, table_id, true);
            } else if (
              data.payment_data !== undefined &&
              data.payment_data !== null
            ) {
              if (terminal_id !== undefined && terminal_id !== '') {
                const wrapper = $('#process-orders-with-terminal-payments');
                if (wrapper.hasClass('d-none')) {
                  wrapper.removeClass('d-none');
                  wrapper.addClass('d-flex');
                }
                const clonedOrderCard = $('.order-card.clone').clone();
                clonedOrderCard.removeClass('clone d-none');
                clonedOrderCard.addClass('processing');
                clonedOrderCard.attr('id', terminal_id);
                clonedOrderCard.find('.terminal-number').text(terminal_number);
                const statusBadge = clonedOrderCard.find('.status-badge');
                statusBadge.addClass('processing text-primary');
                statusBadge.html(
                  `Behandling <div class="spinner-border spinner-border-sm text-primary ml-2" role="status"><span class="sr-only">Loading...</span></div>`
                );
                clonedOrderCard
                  .find('.order-items')
                  .text(locationCart.number_of_products);

                const cancelButton = clonedOrderCard.find('.cancel-btn');
                cancelButton.remove();

                const retryButton = clonedOrderCard.find('.retry-btn');
                retryButton.addClass('retry-btn-' + terminal_id);
                retryButton.attr('disabled', true);
                retryButton.attr('data-terminal-id', terminal_id);
                retryButton.attr(
                  'data-terminal-type',
                  isPax ? 'pax' : 'verifone'
                );

                const showOrderButton = clonedOrderCard.find('.show-order');
                showOrderButton.remove();

                const cancelProcessButton = clonedOrderCard.find(
                  '.cancel-payment-process'
                );
                cancelButton.addClass('cancel-payment-process-' + terminal_id);
                cancelProcessButton.attr(
                  'data-terminal-number',
                  terminal_number
                );
                cancelProcessButton.attr('data-terminal-id', terminal_id);
                cancelProcessButton.attr(
                  'data-terminal-type',
                  isPax ? 'pax' : 'verifone'
                );
                cancelProcessButton.addClass('disabled');
                cancelProcessButton.attr('disabled');

                if (!$('#' + terminal_id).length) {
                  $('#processing-orders').append(clonedOrderCard);
                }

                const payload = {
                  type: 'verifone',
                  action: 'start_payment',
                  temrinalUniqueId: terminal_id,
                  paymentData: data.payment_data,
                  senderDeviceId: localStorage.getItem('deviceID'),
                };

                localStorage.setItem(
                  'vt_' + terminal_id,
                  JSON.stringify(payload)
                );

                sendWhenReady(window.globalSocket, JSON.stringify(payload));
              } else {
                localStorage.setItem(
                  'verifone_payment_data',
                  JSON.stringify(data.payment_data)
                );

                passTerminalDataToWebView(data.payment_data);

                if (
                  $('#paymentProcessSpinner').hasClass('d-none') &&
                  !$('#paymentProcessError').hasClass('d-none')
                ) {
                  $('#paymentProcessSpinner').removeClass('d-none');
                  $('#paymentProcessError').addClass('d-none');

                  const processingMessage =
                    $('#paymentStatus').data('processing-message') ||
                    'Processing Payment...';
                  $('#paymentStatus').text(processingMessage);
                  $('#retryPaymentButton').addClass('d-none');
                }
                $('#paymentProcessModal')
                  .modal({
                    backdrop: 'static',
                    keyboard: false,
                  })
                  .on('shown.bs.modal', function () {
                    $('#retryPaymentButton').addClass('d-none');
                    $('#paymentProcessSpinner').removeClass('d-none');
                    $('#paymentProcessError').addClass('d-none');
                    const processingMessage =
                      $('#paymentStatus').data('processing-message') ||
                      'Processing Payment...';
                    $('#paymentStatus').text(processingMessage);
                    $('#cancelPaymentButton')
                      .html('<div class="loader"></div>')
                      .prop('disabled', true);
                  })
                  .on('hidden.bs.modal', function () {
                    $('#cancelPaymentButton')
                      .html(
                        $('#cancelPaymentButton').data('button-text') ||
                          'Avbryt'
                      )
                      .prop('disabled', false);
                  });
              }
            } else if (
              data.remaining_amount &&
              data.remaining_amount > 0.1 &&
              terminal_id !== undefined &&
              terminal_id !== ''
            ) {
              if (
                table_id &&
                $('#split-payment-cart-modal.show').length > 0 &&
                $('#split-payment-cart-modal').attr('data-table-id') ==
                  table_id &&
                $('#refresh-table-details').hasClass('d-none')
              ) {
                locationCart.table_number = table_id;
                $('#refresh-table-details').removeClass('d-none');
              }
            } else {
              const orderHtml =
                data.order_html !== undefined && data.order_html !== null
                  ? data.order_html
                  : '';
              $('.modal-backdrop').remove();

              const $confirmationStyle = $('#classic-location-products').data(
                'order-confirmation-toast-style'
              );
              $('.confirmation-toast').remove();
              if (orderHtml) {
                $('.confirmation-toast').remove();
                $('#content').append(
                  '<div class="position-fixed bottom-0 right-0 p-3 confirmation-toast" style="z-index: 1001; bottom: 0;' +
                    (window.innerWidth >= 500 ? ' right: 0;' : '') +
                    ' width: 480px; display: none;">' +
                    '<div role="alert" aria-live="assertive" aria-atomic="true" class="toast confirmation-toast-box" data-autohide="' +
                    ($confirmationStyle == 'compact' ? 'false' : 'true') +
                    '" data-delay="' +
                    ($confirmationStyle === 'compact' ? 100000 : 3000) +
                    '">' +
                    '  <div class="toast-header">' +
                    '    <strong class="mr-auto">Ordre registrert</strong>' +
                    '    <small></small>' +
                    '    <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close">' +
                    '      <span aria-hidden="true">&times;</span>' +
                    '    </button>' +
                    '  </div>' +
                    '  <div class="toast-body">' +
                    orderHtml +
                    '  </div>' +
                    '</div>' +
                    '</div>'
                );
              }

              if (
                data.item_count &&
                data.total_amount &&
                $confirmationStyle === 'compact'
              ) {
                showPreviousSaleBar(data.item_count, data.total_amount);

                const productsWithCount = [];

                data.orderProducts.forEach((product) => {
                  const productDetail = `(${product.quantity})${product.name}`;
                  productsWithCount.push(productDetail);
                });

                localStorage.setItem(
                  'lastOrderProducts',
                  JSON.stringify(productsWithCount)
                );
                localStorage.setItem('lastOrderTotal', data.total_amount);

                setLastOrderDetails();
              } else {
                $('.confirmation-toast').css({ padding: '1rem' }).show();
                $('.confirmation-toast-box')
                  .toast('show')
                  .on('hidden.bs.toast', function () {
                    $('.confirmation-toast').attr('style', function (i, s) {
                      return (s || '') + 'padding: 0px !important;';
                    });
                  });

                const productsWithCount = [];

                data.orderProducts.forEach((product) => {
                  const productDetail = `(${product.quantity})${product.name}`;
                  productsWithCount.push(productDetail);
                });

                localStorage.setItem(
                  'lastOrderProducts',
                  JSON.stringify(productsWithCount)
                );
                localStorage.setItem('lastOrderTotal', data.total_amount);

                setLastOrderDetails();
              }

              if (
                table_id &&
                $('#split-payment-cart-modal.show').length > 0 &&
                $('#split-payment-cart-modal').attr('data-table-id') ==
                  table_id &&
                $('#refresh-table-details').hasClass('d-none')
              ) {
                if ($('#split-by-sum').is(':checked')) {
                  $('#split-payment-cart-modal.show').modal('hide');
                } else {
                  $('#refresh-table-details').removeClass('d-none');
                }
              }
            }
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }

          errorPopupAlert(
            data.responseJSON.errors || 'Noe gikk galt under deling av beløp.'
          );
        });
    };
  }
});

function suggestedShareAmount() {
  const remainingAmount = $('#share-amount').data('remaining') ?? 0;
  const personCount = $('.select-person').length;
  const suggestedAmountPerPerson =
    personCount > 0 ? (remainingAmount / personCount).toFixed(2) : 0;

  $('.select-person').each(function () {
    $('#share-amount').val(suggestedAmountPerPerson).trigger('input');
  });
}

function getSavedOrder(
  organizer_id,
  location_id,
  table_id,
  alwaysReopenModal = false
) {
  $.ajax({
    type: 'POST',
    url: '/ajax/order/get_saved_order_table',
    data: {
      organizer_id,
      location_id,
      table_id,
      always_reopen_split_modal: alwaysReopenModal,
    },
  })
    .done(function (data) {
      data.alwaysReopenModal = alwaysReopenModal ? 1 : 0;
      if (
        data.location_id !== undefined &&
        data.location_id !== null &&
        data.location_id == locationId
      ) {
        $('#order-storage-list-modal').modal('hide');
        $('.modal-backdrop').remove();
        if (posType === 'classic') {
          setClassicLocationCart({
            ...data,
            checkout_type: alwaysReopenModal ? 'split' : 'normal',
          });
        } else {
          setLocationCart(data);
        }
        setPerson();
      }

      emptyCartOnModalClose = true;
    })
    .fail(function (data) {
      if (
        data.responseJSON.redirect_url !== undefined &&
        data.responseJSON.redirect_url !== null
      ) {
        document.location.href = data.responseJSON.redirect_url;
      }
    });
}
